import { render, staticRenderFns } from "./ConsultationSelect.vue?vue&type=template&id=bb6e645a&scoped=true&lang=pug"
import script from "./ConsultationSelect.vue?vue&type=script&lang=js"
export * from "./ConsultationSelect.vue?vue&type=script&lang=js"
import style0 from "./ConsultationSelect.vue?vue&type=style&index=0&id=bb6e645a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e645a",
  null
  
)

export default component.exports